module.exports = __webpack_public_path__ + "static/process_and_operational_excellence-7791bbc1c3cd1e24be1547b6b88ade39.jpg";